'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'circle-half-stroke';
var width = 512;
var height = 512;
var aliases = [9680,"adjust"];
var unicode = 'f042';
var svgPathData = ['M32 256c0 118.3 91.8 215.2 208 223.4l0-446.9C123.8 40.8 32 137.7 32 256z', 'M272 479.4l0-446.9C388.2 40.8 480 137.7 480 256S388.2 471.2 272 479.4zm-32 0C123.8 471.2 32 374.3 32 256S123.8 40.8 240 32.6l0 446.9zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;